import { renderHeaderLeftBack } from 'app/lib/navigation/header-renderers';
import { useIsFocused } from '@react-navigation/native';
import { withErrorBoundary } from 'app/components/error-boundary';
import { Text } from 'app/design/primitives/text';
import { useNavigationOptions } from 'app/hooks/navigation';
import { useSocialFeedFeature } from 'app/hooks/use-social-feed-feature';
import { OfferHubStoriesTab } from 'app/screens/offer-hub/components/offer-hub-stories-tab';
import type { NavigationScreen } from 'app/types/navigation';
import { useEffect, useMemo, type ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

export function StoryPicker({ navigation }: ComponentProps<NavigationScreen<'story-picker'>>) {
  const { t } = useTranslation('posts');
  const focused = useIsFocused();
  const { canUseSocialFeed, isSocialFeedLoading } = useSocialFeedFeature();
  const headerOptions = useMemo(
    () => ({
      headerLeft: renderHeaderLeftBack,
      headerBackVisible: false,
      headerTitle: () => (
        <Text variant="bodyBase" fontWeight="600">
          {t('feed.endOfFeed.action')}
        </Text>
      ),
    }),
    [t],
  );
  useNavigationOptions(navigation, headerOptions);
  useEffect(() => {
    if (!isSocialFeedLoading && !canUseSocialFeed) {
      if (navigation.canGoBack()) navigation.goBack();
      else navigation.replace('main', { screen: 'billboard' });
    }
  }, [canUseSocialFeed, isSocialFeedLoading, navigation]);
  if (!canUseSocialFeed) return null;
  return <OfferHubStoriesTab active={focused} visible backInHeader />;
}

const StoryPickerWithBoundary = withErrorBoundary(StoryPicker);

export function StoryPickerScreen(props: ComponentProps<NavigationScreen<'story-picker'>>) {
  return <StoryPickerWithBoundary {...props} />;
}
